import { env } from '@/config/env.ts'
import type { Logger, LogLevel } from './logger.interface.ts'

const LOG_LEVELS: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
}

export function createConsoleLogger(minLevel?: LogLevel): Logger {
  const threshold =
    LOG_LEVELS[minLevel ?? (env.isDevelopment ? 'debug' : 'warn')]

  function shouldLog(level: LogLevel): boolean {
    return LOG_LEVELS[level] >= threshold
  }

  return {
    debug(message: string, ...args: unknown[]) {
      if (shouldLog('debug')) console.debug(`[DEBUG] ${message}`, ...args)
    },
    info(message: string, ...args: unknown[]) {
      if (shouldLog('info')) console.info(`[INFO] ${message}`, ...args)
    },
    warn(message: string, ...args: unknown[]) {
      if (shouldLog('warn')) console.warn(`[WARN] ${message}`, ...args)
    },
    error(message: string, ...args: unknown[]) {
      if (shouldLog('error')) console.error(`[ERROR] ${message}`, ...args)
    },
  }
}
